import { create } from 'zustand';
import { PaletteMode } from '@mui/material';
import { checkCookiesMode, changeCookiesMode } from '../utils/theme/dark-mode';

interface ThemeState {
  mode: PaletteMode;
  toggleMode: () => void;
  toggleTheme: () => void;
}

export const useThemeStore = create<ThemeState>((set) => ({
  mode: checkCookiesMode(),
  toggleMode: () =>
    set((state) => {
      const newMode = state.mode === 'light' ? 'dark' : 'light';
      changeCookiesMode(newMode);
      return { mode: newMode };
    }),
  toggleTheme: () =>
    set((state) => {
      const newMode = state.mode === 'light' ? 'dark' : 'light';
      changeCookiesMode(newMode);
      return { mode: newMode };
    }),
}));